import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import sevenNowLogo from '../../../../public/assets/img/seven-now-logo.svg';
import { TextField, CardContent, Card, Grid, styled, InputAdornment } from '@mui/material';
import { CircularProgressLoader } from '../../../shared/components/Loaders';
import {
  DELIVERY_TIME,
  EMAIL_VERBIAGE,
  IMAGES,
  LAUNCH_TIME,
  LOCATION_LIST,
  LOGIN_VERBIAGE,
  REDIRECT_CONNECT_POPOVER,
  RESTRICT_MODEL,
} from '../../../constants/landingConstant';
import { CONNECT, LOG_IN, MERCHANT_PORTAL_TEXT, MINI_CHAR, PASSWORD_REQUIRED, PASS_MINI_CHAR, USERNAME_EMAIL_REQUIRED } from '../../../constants/buttonConstants';
import { useDispatch, useSelector } from 'react-redux';
import WarningTriangle from '../../../../public/assets/img/warning.svg';
import CustomPopOver from '../../../shared/pop-over/custom.pop-over';
import { getClearResponse } from '../../../redux/actions/checkmateAuthorizationAction';
import { getAuthUser } from '../../../redux/actions/amazonWebServicesAction';
import { loginUsingCode } from '../../../api/otter.api';
import { authUserWithCodeSuccess, setInitialRoute, updateAppOrgName } from '../../../redux/actions/merchantAction';
import { appOrganizationSaga, appTokenSaga } from '../../../redux/saga/merchantServiceSelectors';
import { loginResponseSaga, refreshLogicSaga } from '../../../redux/saga/loginServiceSelector';
import { delete_cookie, getCookie, getTargetDate, restrictOnlyFewSpecialChara, validateUserNameandEmail } from '../../../shared/utils/format.helpers';
import { authenticateUserRequest, restoreUserSession } from '../../../redux/actions/loginServiceAction';
import { encryptPassword } from '../../../shared/utils/common';
import { useCookies } from 'react-cookie';
import { LOGIN_FAILED_ERROR, LOGIN_FAILED_TIMEOUT } from '../../../constants/merchantsConstants';

const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
        color: '#111111',
        fontWeight: '700'
    },
});

const buttonStyle = {
	backgroundColor: '#E6F1EE',
	borderRadius: '20px',
	borderColor: 'transparent',
	fontSize: '16px',
	lineHeight: '24px',
	fontWeight: '700',
	height: '40px',
	width: '100%',
	color: '#00563C',
};

const LoginOtter = ({ orgName }) => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [userNameCard, setUserNameCard] = useState(false);
	const [userName, setUserName] = useState('');
	const [password, setPassword] = useState('');
	const [userNameError, setUserNameError] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	const [userNameErrorMsg, setUserNameErrorMsg] = useState('');
	const [passwordErrorMsg, setPasswordErrorMsg] = useState('');
	const [loginErrorMsg, setloginErrorMsg] = useState('');
	const [formValid, setformValid] = useState(false);
	const [popOverTitle, setpopOverTitle] = useState();
	const [merchantAccountView, setmerchantAccountView] = useState();
	const [listData, setlistData] = useState(null);
	const [listTitle, setlistTitle] = useState('');
	const [listControl, setlistControl] = useState('');
	const [primaryButtonText, setprimaryButtonText] = useState('');
	const [open, setOpen] = useState(false);
	const [selectedValue, setSelectedValue] = useState('');
	const [showLowerDescription, setshowLowerDescription] = useState('');
	const [listHeight, setListHeight] = useState('100px');
	const [apiInProgress, setapiInProgress] = useState(false);
	const refreshLogic = useSelector(refreshLogicSaga);
	const [emailWord, setEmailWord] = React.useState('');
	const { state } = useLocation();
	const [cookies, setCookie, removeCookie] = useCookies(['_tMerV', '_cMerV','_rMerV']);

	const orgNameSelector = useSelector(appOrganizationSaga);
	const loginResponseData = useSelector(loginResponseSaga);

	const appTokenSagaSelector = useSelector(appTokenSaga);

	const [queryParameters] = useSearchParams();

	const reqEmail = process.env.REQUEST_ACCESS_MAIL;

	const validateUserNameandEmail = (userinput) => {
		let exp = /^[A-Za-z0-9!#@%*.:_^-]*$/;
		return userinput.split(' ').length === 1 && exp.test(userinput);
	};
	const restrictOnlyFewSpecialChara = (val) => {
		let exp = /^[a-zA-Z0-9!#@%*:_^-]+$/;
		return exp.test(val);
	};
	const getTargetDate = () => {
		var targetDate = new Date();
		targetDate.setDate(targetDate.getDate() + 7);
		return targetDate.toUTCString();
	};

	useEffect(() => {
		if(appTokenSagaSelector){
		let emailWordText = EMAIL_VERBIAGE;
		emailWordText = emailWordText.replace('[email]', reqEmail);
		setEmailWord(emailWordText);
		sessionStorage.setItem('orgName', 'Otter');
		dispatch(updateAppOrgName('Otter'));
	
		if (getCookie('_cMerV') && getCookie('_tMerV') && loginResponseData === null && sessionStorage.getItem('merchantAuth') === 'true') {
			if (JSON.parse(JSON.stringify(cookies['_tMerV']))?.idToken) {
			dispatch(restoreUserSession(cookies['_tMerV'], cookies['_cMerV'], cookies['_rMerV']));
			}
		} else if (sessionStorage.getItem('merchantAuth') !== 'true') {
			delete_cookie('_tMerV', '/', '');
			delete_cookie('_cMerV', '/', '');
			delete_cookie('_rMerV', '/', '');
		}
	
		if (queryParameters.get('code') && sessionStorage.getItem('merchantAuth') === 'true') {
			setapiInProgress(true);
			loginUsingCode(queryParameters.get('code')).then(
			(res) => {
				if (!res.message) {
				dispatch(authUserWithCodeSuccess(res?.data['access_token']));
				dispatch(setInitialRoute('otter'));
				navigate('/dashboard-brand');
				}
			},
			(err) => {
				console.log('ERR ', err);
			}
			);
			event.preventDefault();
		} else {
			sessionStorage.setItem('merchantAuth', 'false');
		}
		}
		
	}, [appTokenSagaSelector]);


	useEffect(()=>{
		if(userNameCard){
			setformValid(userName !== '' && validateUserNameandEmail(userName));
		} else {
			setformValid(userName !== '' && validateUserNameandEmail(userName) && password !== '' && restrictOnlyFewSpecialChara(password));
		}
	},[userName, password]);

	useEffect(() => {
		if (loginResponseData) {
			setapiInProgress(false);
			// console.log('LOGIN DATA ',loginResponseData)
			if (loginResponseData && !loginResponseData?.msg) {
			let targetDate;
			let tMerObj;
			let cMerObj;
			let rMerObj;
		
			if (loginResponseData?.idToken && !refreshLogic) {
				targetDate = getTargetDate(loginResponseData?.tokenTime);
		
				tMerObj = {
				idToken: loginResponseData.idToken,
				tokenTime: loginResponseData.tokenTime,
				};
				document.cookie = `_tMerV=${JSON.stringify(tMerObj)};expires=${targetDate};path=/;secure`;
		
				rMerObj = {
				refreshToken: loginResponseData.refreshToken,
				};
				document.cookie = `_rMerV=${JSON.stringify(rMerObj)};expires=${targetDate};path=/;secure`;
		
		
				cMerObj = {
				accessToken: loginResponseData.accessToken,
				expiresIn: loginResponseData.expiresIn,
				aggregator: loginResponseData.aggregator,
				merchantId: loginResponseData.merchantId,
				isAdmin: loginResponseData.isAdmin,
				userName: loginResponseData.userName,
				emailId: loginResponseData.emailId,
				};
		
				document.cookie = `_cMerV=${JSON.stringify(cMerObj)};expires=${targetDate};path=/;secure`;
			}
			}
		if (loginResponseData?.idToken) {
			setUserNameError(false);
			setPasswordError(false);
			setUserNameErrorMsg('');
			setPasswordErrorMsg('');
			if (loginResponseData.isAdmin) {
			dispatch(getAuthUser(true));
			dispatch(setInitialRoute(''));
			sessionStorage.setItem('isAdmin', true);
			navigate('/dashboard/adminhomepage');
			} else {
			dispatch(getAuthUser(true));
			dispatch(updateAppOrgName('Otter'));
			dispatch(setInitialRoute('otter'));
			sessionStorage.setItem('merchantAuth', 'true');
			showAuthentictePopOver();
			
			}
		} else {
			setapiInProgress(false);
			// console.log('DD ',loginResponseData.details, loginResponseData.details?.data?.message);
			if (loginResponseData.details?.data?.message) {
			setUserNameError(true);
			setPasswordError(true);
			setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
			setPasswordErrorMsg(PASSWORD_REQUIRED);
			setloginErrorMsg(String(loginResponseData.details?.data?.message));
			} else if (loginResponseData.details?.code === 'ECONNABORTED') {
			setUserNameError(true);
			setPasswordError(true);
			setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
			setPasswordErrorMsg(PASSWORD_REQUIRED);
			setloginErrorMsg(LOGIN_FAILED_TIMEOUT);
			} else {
			setUserNameError(true);
			setPasswordError(true);
			setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
			setPasswordErrorMsg(PASSWORD_REQUIRED);
			setloginErrorMsg(LOGIN_FAILED_ERROR);
			}
		}
		}
	}, [loginResponseData]);

	const handleLogin = (e) => {
		e.preventDefault();
		setUserNameError(false);
		setPasswordError(false);
		setUserNameErrorMsg('');
		setPasswordErrorMsg('');
		setloginErrorMsg('');
		dispatch(getClearResponse({}));
		validation()
		.then(
			(res) => {
			if (res.userName === '' && res.password === '' && formValid) {
				setapiInProgress(true);
				const encryptedPassword = encryptPassword(password);
				dispatch(authenticateUserRequest(userName, encryptedPassword));
			}
			},
			(err) => {
			setapiInProgress(false);
			console.log(err);
			}
		)
		.catch((err) => {
			setapiInProgress(false);
			console.log(err);
		});
	};

	const validation = () => {
		return new Promise((resolve, reject) => {
		if (userName === '' && password === '') {
			setUserNameError(USERNAME_EMAIL_REQUIRED);
			setPasswordError(PASSWORD_REQUIRED);
			setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
			setPasswordErrorMsg(PASSWORD_REQUIRED);
			resolve({ userName: USERNAME_EMAIL_REQUIRED, password: PASSWORD_REQUIRED });
		} else if (userName === '') {
			setUserNameError(USERNAME_EMAIL_REQUIRED);
			setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
			resolve({ userName: USERNAME_EMAIL_REQUIRED, password: '' });
		} else if (password === '') {
			setPasswordError(PASSWORD_REQUIRED);
			setPasswordErrorMsg(PASSWORD_REQUIRED);
			resolve({ userName: '', password: PASSWORD_REQUIRED });
		} else if (password.length < 6) {
			setPasswordError(MINI_CHAR);
			setPasswordErrorMsg(PASS_MINI_CHAR);
			resolve({ userName: '', password: PASS_MINI_CHAR });
		} else {
			setUserNameError(false);
			setPasswordError(false);
			setUserNameErrorMsg('');
			setPasswordErrorMsg('');
			resolve({ userName: '', password: '' });
		}
		});
	};

	const showAuthentictePopOver = () => {
		setprimaryButtonText(CONNECT);
		setlistTitle(REDIRECT_CONNECT_POPOVER.TITLE_ONE);
		setpopOverTitle(<p className='heading-block'>{REDIRECT_CONNECT_POPOVER.TITLE}</p>);
		setmerchantAccountView(
		<Grid container>
			<Grid item>{REDIRECT_CONNECT_POPOVER.CLAUSE_ONE}</Grid>
		</Grid>
		);
		setSelectedValue(orgName);
		setOpen(true);
	};

	const handleClose = (value) => {
		if (value) {
		window.location.href = `${process.env.OTTER_HOST_URL}/v1/auth/oauth2/authorize?client_id=${process.env.OTTER_CLIENT_ID}&redirect_uri=${process.env.OTTER_REDIRECT_URL}&response_type=code&scope=organization.read organization.service_integration&state=${process.env.OTTER_STATE_ID}`;
		} else {
		sessionStorage.setItem('merchantAuth', 'false');
		dispatch(getAuthUser(false));
		}
		setOpen(false);
	};

	const userAccountList = (landingStyle) => {
		return (
		<div className={landingStyle ? 'content-leftPanel' : ''}>
			{landingStyle ? (
			<>
				<p>{LOGIN_VERBIAGE}</p>
			</>
			) : (
			''
			)}
			<li>{LOCATION_LIST}</li>
			<li>{DELIVERY_TIME}</li>
			<li>{LAUNCH_TIME}</li>
			<li>{IMAGES}</li>
		</div>
		);
	};

	//commenting for now as its not being used
	//const showRestrictionPopup = () => {
	//	let emailWordText = RESTRICT_MODEL.CLAUSE_TWO;
	//	emailWordText = emailWordText.replace('[email pending]', process.env.REQUEST_ACCESS_MAIL);
	//	//console.log('EMAIL TEXT ', emailWordText)
	//	setprimaryButtonText(null);
	//	setSelectedValue([]);
	//	setpopOverTitle(
	//	<Grid container spacing={1}>
	//		<Grid item>
	//		<p className='heading-block'>{RESTRICT_MODEL.HEADER_LEFT}</p>
	//		</Grid>
	//		<Grid item xs={6} md={6}>
	//		<p className='heading-grey'>{RESTRICT_MODEL.HEADER_RIGHT}</p>
	//		</Grid>
	//	</Grid>
	//	);
	//	setmerchantAccountView(
	//	<Grid container>
	//		<Grid item>
	//		<p>{RESTRICT_MODEL.CLAUSE_ONE}</p>
	//		</Grid>
	//		<Grid item>
	//		<p>{emailWordText}</p>
	//		</Grid>

	//		<Grid item>
	//		<p style={{ marginBottom: '0' }}>{RESTRICT_MODEL.CLAUSE_THREE}</p>
	//		</Grid>
	//	</Grid>
	//	);
	//	setlistData(null);
	//	setOpen(true);
	//};

	return (
		<>
		<Container fluid className='vh-100 d-flex flex-column ' data-testid='LoginOtter-id'>
			<Row className='h-100'>
			<Col className='background-white-class'>
				<Row className='margin_Panel'></Row>
				<Row>
				<Col xs={14}>
					<div className='landing-logo-holder aligncenter'>
					<img src={sevenNowLogo} className='img-right-align' alt='SevenNow header Logo' />
					<h2 className='merchant-title1'> {MERCHANT_PORTAL_TEXT}</h2>
					</div>
					{userAccountList(true)}
				</Col>
				</Row>
			</Col>
			<Col className='cont-background'>
				<Row className='margin_Panel'></Row>
				<Row>
				<Col xs={2}></Col>
				<Col xs={8}>
					<Card variant='outlined' className='cont-min-class2'>
					<CardContent className='login-card'>
						<form className='display-grid' autoComplete='off' onSubmit={handleLogin}>
						<p className='p-class'> {LOG_IN}</p>
						<br />
						<CssTextField
							id='custom-css-outlined-input1'
							label='Username / Email'
							onChange={(e) => setUserName(e.target.value)}
							variant='outlined'
							color='secondary'
							type='text'
							sx={{ mb: 3 }}
							fullWidth
							value={userName}
							error={!!userNameError}
							helperText={userNameErrorMsg}
							data-testid='username-input'
							InputProps={{
							endAdornment: <InputAdornment position='end'>{userNameError ? <img src={WarningTriangle} className='error-icon' /> : null}</InputAdornment>,
							}}
						/>
						<CssTextField
							id='custom-css-outlined-input2'
							label='Password'
							onChange={(e) => setPassword(e.target.value)}
							variant='outlined'
							color='secondary'
							type='password'
							value={password}
							error={!!passwordError}
							helperText={passwordErrorMsg}
							autoComplete='on'
							fullWidth
							sx={{ mb: 3 }}
							InputProps={{
							endAdornment: <InputAdornment position='end'>{passwordError ? <img src={WarningTriangle} className='error-icon' /> : null}</InputAdornment>,
							}}
							inputProps={{ 'data-testid': 'password-input' }}
						/>
						<p className='warning-msg' data-testid='incorrect-logins' >{loginErrorMsg}</p>
						<button style={{ ...buttonStyle, ...{ backgroundColor: '#00563C', color: 'white' } }} variant='outlined' data-testid='login-button' type='submit'>
							{!userNameCard ? LOG_IN : SEND_EMAIL}
						</button>
						</form>
					</CardContent>
					</Card>
				</Col>
				<Col xs={2}></Col>
				</Row>
			</Col>
			</Row>
		</Container>

		<CustomPopOver
			title={popOverTitle}
			descriptionContent={merchantAccountView}
			selectedValue={selectedValue}
			open={open}
			listHeight={listHeight}
			showLowerDescription={showLowerDescription}
			listTitle={listTitle}
			listData={listData}
			listControl={listControl}
			listSelectAll={true}
			primaryButton={primaryButtonText}
			onClose={handleClose}
			data-testid='authentication-connectPopover'
		/>

		{apiInProgress === true ? (
			<div className='loader-style'>
			<CircularProgressLoader />
			</div>
		) : null}
		</>
	);
};

export default LoginOtter;
